module.exports = __webpack_public_path__ + "static/media/docs-badge.5dacfe59.svg";